module.exports = vendor_59c82b32db54b834106a;